// This function allow to reference async chunks
__webpack_require__.k = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "." + "e6c7152fb585ddbd7ab5" + ".css";
};